import './assets/main.css'

import { createApp } from 'vue'
import router from './router';  // 确保你已经创建了 router 实例
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue'
import 'element-plus/dist/index.css'; // 默认样式
import { createPinia } from 'pinia'
import i18n from './utils/i18n'
const app = createApp(App);

app.use(i18n);

const pinia = createPinia()
app.use(pinia)

app.use(ElementPlus);
app.use(router);

app.mount('#app');
